import React from 'react';

const NotificationIcon = ({ fill = "#019B57", className = "", active = true, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        {...props}
    >
        {/* Symmetric bell icon */}
        <path
            d="M12 22c1.104 0 2-.896 2-2h-4c0 1.104.896 2 2 2zm6-6v-5c0-3.313-2.687-6-6-6s-6 2.687-6 6v5l-1.707 1.707A1 1 0 0 0 6 19h12a1 1 0 0 0 .707-1.707L18 16zm-2 1H8v-6c0-2.21 1.79-4 4-4s4 1.79 4 4v6z"
            fill={fill}
        />
        {/* Only render the green dot if active */}
        {active && (
            <circle cx="19" cy="5" r="2.5" fill="#00D97E" stroke="white" strokeWidth="1" />
        )}
    </svg>
);

export default NotificationIcon;